var data = {
  async init() {
    var { constants } = await app.api.constant.get();
    data.constants = constants;
  },
  distribution: {
    target_types: [
      { id: "all", label: "全ユーザーに配布" },
    ],
  },
  beforeunload_text: '保存していない変更があります。\nページを離れますか？',
  storage_key: {
    last_seen: 'loyn_last_seen', 
  },
  buy_points_url: 'https://docs.google.com/forms/d/e/1FAIpQLScdt6Jc37TEACdtJUSmDclClLMyC24AVNLA0AlUDMWOWYecgA/viewform',
  help_page_url: 'https://repro.io/products/incentive/help/',
  validation: {
    'paypay': {
      amount: {
        input: {
          min: 1,
          max: 1000000,
          title: '1〜1,000,000の整数を入力してください',
        },
      },
    },
    'ponta': {
      amount: {
        input: {
          min: 1,
          max: 999999,
          title: '1〜999,999の整数を入力してください',
        },
      },
    },
    'point_at_gift': {
      amount: {
        input: {
          min: 1,
          max: 999999,
          title: '1〜999,999の整数を入力してください',
        },
      },
    },
    'google_play_gift_code': {
      amount: {
        input: {
          min: 100,
          max: 50000,
          title: '100〜50,000の整数を入力してください',
        },
      },
    },
    'apple_gift_card': {
      amount: {
        input: {
          min: 100,
          max: 50000,
          title: '100〜50,000の整数を入力してください',
        },
      },
    },
    'amazon_gift_card': {
      amount: {
        input: {
          min: 1,
          max: 500000,
          title: '100〜50,000の整数を入力してください',
        },
      },
    },
    'test_point_provider': {
      amount: {
        input: {
          min: 1,
          max: 1000000,
          title: '1〜1,000,000の整数を入力してください',
        },
      },
    },
  },
};

module.exports = data;
